import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center w-25" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "mx-auto" }
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_error_component = _resolveComponent("error-component")!
  const _component_v_main = _resolveComponent("v-main")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      app: "",
      absolute: "",
      height: "70",
      color: "#c9d304",
      flat: "",
      class: "position-fixed ma-0"
    }, {
      prepend: _withCtx(() => [
        _createVNode(_component_v_img, {
          cover: "",
          style: {"width":"200px","height":"100%"},
          src: _ctx.logo
        }, null, 8, ["src"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_row, { class: "ma-0 pt-4 w-100 align-baseline" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_icon, {
              color: "#9b267c",
              size: "22"
            }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("mdi-map-marker-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createElementVNode("small", {
              style: {"color":"#9b267c"},
              class: "text-h5 font-weight-medium"
            }, "Mozambique", -1)),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_icon, {
              color: "#9b267c",
              size: "22"
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode("mdi-map-marker-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[8] || (_cache[8] = _createElementVNode("small", {
              style: {"color":"#9b267c"},
              class: "text-h5 font-weight-medium"
            }, "Johannesburg", -1)),
            _createVNode(_component_v_spacer),
            _createVNode(_component_v_icon, {
              color: "#9b267c",
              size: "22"
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("mdi-map-marker-outline", -1)
              ]))]),
              _: 1
            }),
            _cache[9] || (_cache[9] = _createElementVNode("small", {
              style: {"color":"#9b267c"},
              class: "text-h5 font-weight-medium"
            }, "Lisboa", -1)),
            _createVNode(_component_v_spacer)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, {
      class: "pt-0",
      style: {"height":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: ""
        }, {
          default: _withCtx(() => [
            _cache[22] || (_cache[22] = _createElementVNode("h1", { class: "text-h4 text-center text-primary-lighten-1" }, " Simulação de Envio ", -1)),
            _createElementVNode("div", null, [
              _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-primary-lighten-2 text-center text-body" }, " Assimule um envio e tenha ideia de quanto podera pagar ", -1)),
              _createVNode(_component_v_row, { class: "ma-0 justify-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_row, { class: "ma-0" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-subtitle-1 text-left text-medium-emphasis" }, " Origem ", -1)),
                            _createVNode(_component_v_autocomplete, {
                              density: "compact",
                              "hide-details": "auto",
                              items: _ctx.scales,
                              disabled: _ctx.scales.length == 0 ? true : false,
                              loading: _ctx.scales.length == 0 ? true : false,
                              "return-object": "",
                              "item-title": "name",
                              "item-value": "id",
                              modelValue: _ctx.origin,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.origin) = $event)),
                              variant: "outlined"
                            }, null, 8, ["items", "disabled", "loading", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          class: "pl-0 pt-0"
                        }, {
                          default: _withCtx(() => [
                            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "text-subtitle-1 text-left text-medium-emphasis" }, " Destino ", -1)),
                            _createVNode(_component_v_autocomplete, {
                              density: "compact",
                              "hide-details": "auto",
                              items: _ctx.scales,
                              disabled: _ctx.scales.length == 0 ? true : false,
                              loading: _ctx.scales.length == 0 ? true : false,
                              "return-object": "",
                              "item-title": "name",
                              "item-value": "id",
                              modelValue: _ctx.destiny,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.destiny) = $event)),
                              variant: "outlined"
                            }, null, 8, ["items", "disabled", "loading", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          class: "pt-0"
                        }, {
                          default: _withCtx(() => [
                            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-subtitle-1 text-left text-medium-emphasis" }, " Serviço ", -1)),
                            _createVNode(_component_v_autocomplete, {
                              density: "compact",
                              "hide-details": "auto",
                              items: _ctx.services,
                              disabled: _ctx.services.length == 0 ? true : false,
                              loading: _ctx.services.length == 0 ? true : false,
                              "return-object": "",
                              "item-title": "name",
                              "item-value": "id",
                              modelValue: _ctx.service,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.service) = $event)),
                              variant: "outlined"
                            }, null, 8, ["items", "disabled", "loading", "modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "6",
                          class: "pl-0 pt-0"
                        }, {
                          default: _withCtx(() => [
                            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-subtitle-1 text-left text-medium-emphasis" }, " Peso ", -1)),
                            _createVNode(_component_v_text_field, {
                              modelValue: _ctx.weight,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.weight) = $event)),
                              modelModifiers: { number: true },
                              color: "primary",
                              "base-color": "primary",
                              variant: "outlined",
                              "hide-details": "auto"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { class: "ma-0 justify-center" }, {
                default: _withCtx(() => [
                  (!_ctx.hasData)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        "prepend-icon": "mdi-check",
                        color: "primary",
                        variant: "tonal",
                        onClick: _withModifiers(_ctx.simulate, ["prevent"]),
                        loading: _ctx.btnLoading
                      }, {
                        default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                          _createTextVNode(" Simular ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick", "loading"]))
                    : (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        "prepend-icon": "mdi-close",
                        color: "primary",
                        variant: "tonal",
                        onClick: _withModifiers(_ctx.clearData, ["prevent"])
                      }, {
                        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                          _createTextVNode(" Limpar ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]))
                ]),
                _: 1
              })
            ]),
            _withDirectives(_createVNode(_component_v_row, { class: "ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "6",
                  class: "mx-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      class: "pa-4",
                      color: "muted"
                    }, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createElementVNode("h4", null, "Resultado", -1)),
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("h5", null, [
                            _cache[17] || (_cache[17] = _createTextVNode(" O valor de envio de ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.cotResult.weight) + "KG ", 1),
                            _cache[18] || (_cache[18] = _createTextVNode(" na rota ", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.cotResult.route), 1),
                            _cache[19] || (_cache[19] = _createTextVNode(" é de ", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.cotResult.price) + "mts", 1),
                            _cache[20] || (_cache[20] = _createTextVNode(". ", -1))
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.hasData]
            ]),
            _createVNode(_component_v_row, { class: "ma-0" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "10",
                  class: "mx-auto"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      color: "primary-lighten-2",
                      "prepend-icon": "mdi-information-outline",
                      text: "O vaor da simulação poderá sofrer alterações devido a outras taxas adicionais, este é epenas valor aproximado sem taxas aplicadas.",
                      title: "Valor Sujeito a Alterações"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_footer, {
          app: "",
          height: "80",
          class: "bg-pd-primary px-0 d-flex flex-column"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { class: "ma-0 w-100" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_col, { cols: "10" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("span", {
                          style: {"font-size":"16px"},
                          class: "text-tertiary"
                        }, " Contactos - Maputo - Sede : Av Acordos de Lusaka, nº 3237 | Tell: +258 82 120 8151 / +258 84 120 8151; ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                        _createElementVNode("span", {
                          style: {"font-size":"16px"},
                          class: "text-tertiary"
                        }, [
                          _createTextVNode(" Email: "),
                          _createElementVNode("a", {
                            class: "text-decoration-none text-tertiary",
                            href: "mailto:info@portadordiario.co.mz"
                          }, " info@portadordiario.co.mz "),
                          _createTextVNode(", Web: "),
                          _createElementVNode("a", {
                            class: "text-decoration-none text-tertiary",
                            href: "https://www.portadordiario.co.mz"
                          }, "www.portadordiario.co.mz")
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { class: "" }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createElementVNode("span", {
                          style: {"font-size":"16px"},
                          class: "mx-auto text-tertiary"
                        }, " Siga-nos ", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_3, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, i) => {
                            return (_openBlock(), _createElementBlock("a", {
                              key: i,
                              href: icon.link,
                              target: "_blank",
                              class: "text-decoration-none text-white"
                            }, [
                              _createVNode(_component_v_icon, {
                                color: "White",
                                size: "26"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(icon.name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ], 8, _hoisted_4))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer)
              ]),
              _: 1
            }),
            _cache[26] || (_cache[26] = _createElementVNode("div", {
              class: "bg-tertiary",
              style: {"height":"6px","width":"100%","margin-bottom":"4px","margin-top":"4px"}
            }, null, -1)),
            _createVNode(_component_v_divider)
          ]),
          _: 1
        }),
        _createVNode(_component_error_component, {
          dialog: _ctx.errorDialog,
          message: _ctx.errorMsg,
          onClose: _ctx.closeErrorDialog
        }, null, 8, ["dialog", "message", "onClose"])
      ]),
      _: 1
    })
  ], 64))
}